import React, { useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { Box, Button } from '@mui/material';
import MeetingService from 'services/MeetingService';
import { useMeetingHubContext } from 'components/meetings/MeetingPage/MeetingHubContext';
import { defaultSnackbarErrorProps } from 'util/layout';

import styles from './VotingTimerActions.module.scss';

const VotingTimerActions: React.FunctionComponent = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { meetingId } = useMeetingHubContext();

  const startVotingTimer = useCallback(
    (seconds: number) => {
      MeetingService.startVotingTimer(meetingId, seconds).catch((error: string) => {
        enqueueSnackbar(`Failed to start timer`, defaultSnackbarErrorProps);
        console.error('Error starting timer:', error);
      });
    },
    [enqueueSnackbar, meetingId]
  );

  return (
    <Box className={styles.buttonGroup}>
      <Button variant="contained" color="secondary" onClick={() => startVotingTimer(10)}>
        10s Timer
      </Button>
      <Button variant="contained" color="secondary" onClick={() => startVotingTimer(20)}>
        20s Timer
      </Button>
    </Box>
  );
};

export default VotingTimerActions;
